import { AxiosResponse } from 'axios';
import { axiosClient } from 'services/ApiClient';

export const loadPalettes = (projectId: string): Promise<AxiosResponse<FastBoard.API.ProjectPalettesResponseDTO>> =>
  axiosClient.get(`/api/v2/project/${projectId}/palettes`);
